//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

export abstract class UserUrlConstants
{
	public static onboardingIdentifierVariable: string = `$onboardingIdentifier`;
	public static apiCompleteOnboardingUrlTemplate: string = `/api/Users/CompleteOnboarding?onboardingIdentifier=$onboardingIdentifier`;
}
